module.exports = __webpack_public_path__ + "static/img/bg-secondary-banner-prefabrication-posterImg.16a729f2.png";